import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming you have a similar function to log actions
import {
  getDocDataById,
  getDocDataByRef,
  getOrgDataById,
  getUserDataById,
  queryCollection,
} from "../../models/DataFunctions";
import dayjs from "dayjs";

function getUrlAndText(content) {
  let url = "";
  let text = "";
  if (content) {
    for (let i = 0; i < content.length; i++) {
      if (content[i].startsWith("http")) {
        url = content[i];
      } else {
        text = content[i];
      }
    }
  }

  return {
    url,
    value: text,
  };
}

const sendConformityReport = async (
  folder_id,
  control_id,
  categories_selected,
  file_name,
  document_title,
  token,
  prefix,
  handleClickVariant,
  controlForm = false,
) => {
  let url = prefix + `folders/${folder_id}/conformite`;
  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const folderData = await getDocDataById("folder", folder_id);
  let conductor_name = "Particulier";
  if (folderData.conductor_id) {
    let conductor = await getUserDataById(folderData.conductor_id);
    conductor_name = conductor?.display_name;
  }
  const member = await getUserDataById(folderData.members_id[0]);
  const master = await getOrgDataById(folderData.master_id);

  const control = await getDocDataById("control", control_id);

  let all_list = [];
  for (let i = 0; i < control.cochamps.length; i++) {
    const categorie = control.cochamps[i];
    if (categories_selected.includes(categorie.name)) {
      let champs = categorie.champs.map((c) => {
        if (c.type === "imgtext") {
          return {
            name: c.name,
            value: getUrlAndText(c.content).value,
            urls: [getUrlAndText(c.content).url].filter((cont) =>
              cont.startsWith("http"),
            ),
          };
        } else if (c.type === "img") {
          return {
            name: c.name,
            value: "",
            urls: (c.content || []).filter((cont) => cont.startsWith("http")),
          };
        } else if (c.type === "text") {
          return {
            name: c.name,
            value: c.content[0] || "",
            urls: [],
          };
        }
      });
      champs = champs.filter((c) => c && (c.value !== "" || c.urls.length > 0));
      all_list = [...all_list, ...champs];
    }
  }

  // add pressions and non conformites to pictures
  const pictures = [...all_list];

  let body = {
    control_form: controlForm,
    logo_url: master.logo,
    report: {
      number: dayjs().format("YYYYMMDDHHmmss"),
      date: dayjs().format("DD/MM/YYYY"),
      title: document_title,
      file_name: file_name,
    },
    author: {
      name: member.display_name,
      company: master.name,
    },
    partner: {
      name: conductor_name,
      company:
        folderData.client_type === "particulier"
          ? folderData.nom
          : folderData.marque,
    },
    client: {
      nom: folderData.nom || "",
      adresse: folderData.adresse || "Pas d'adresse renseignée",
      city: folderData.ville || "Pas de ville renseignée",
      postal_code: folderData.postal || "Pas de code postal renseigné",
    },
    pictures: pictures,
  };

  try {
    let start = new Date();
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      console.error("User not logged in");
      return true;
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return true;
    }

    const org_id = userSnapshot.get("org_id");
    const responseText = await response.text();

    let end = new Date();
    let elapsed = end - start;
    // Add log document (avoid passing full document references)
    await addLogDocument(
      url,
      prefix,
      userRef, // Only log the userRef ID
      org_id,
      response.status.toString(),
      "", // folderid
      "", // docid
      JSON.stringify(body), // request body as string
      responseText,
      "POST",
      elapsed,
    );

    // Check if the request was successful
    if (response.ok) {
      // Handle successful response
      const responseJson = JSON.parse(responseText);
      return responseJson;
    } else {
      // Handle error response
      console.error(`Failed to send rt batiment: ${response.status}`);
      return false;
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return false;
  }
};

export default sendConformityReport;
